import { 
    ACTUALIZAR_LIST_ACTIVO,
    AGREGAR_ACTIVO,
    MODIFICAR_ACTIVO,
    ACTUALIZAR_PROCS_PROGRAMADOS,
    ACTUALIZAR_DOCSXACTIVO,
    SET_FILTERS,
    SET_INFO_DASHBOARD_ACTIVOS,
    MODIFICAR_FILTROS_RANGO,
    MODIFICAR_FILTROS_ESTADOS,
    MODIFICAR_FILTROS,
    INICIALIZAR_FILTROS
  } from "./activoActions";

  const activoReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_ACTIVO: {
            return {
                ...state,
                activoList: action.payload,
                cargandoActivos: false
            }
        };

        case AGREGAR_ACTIVO:{
            return {
                 ...state,
                 activoList: [action.payload, ...state.activoList]
             }
         };

         case MODIFICAR_ACTIVO: {
            return {
                ...state,
                activoList: state.activoList.map((g) => g._id === action.payload._id ? action.payload : g)
            }
        };
        
        case ACTUALIZAR_PROCS_PROGRAMADOS:{
            return {
                ...state,
                procsProgramadosList: action.payload,
                cargandoProcsProgramados:false,
            }
        };

        case MODIFICAR_FILTROS: {
            return {
                ...state,
                filtrosProcsProgramadosEstado: action.payload.filtrosEstado,
                filtrosProcsProgramadosRango: action.payload.filtrosRango,
                cargandoProcsProgramados:true
            }
        }
        
        case INICIALIZAR_FILTROS: {
            return {
                ...state,
                filtrosProcsProgramadosEstado: action.payload.filtrosEstado,
                filtrosProcsProgramadosRango: action.payload.filtrosRango,
                cargandoProcsProgramados:true,
                filtrosProcsInicializados:true
            }
        }

        case MODIFICAR_FILTROS_RANGO: {
            return {
                ...state,
                filtrosProcsProgramadosRango: action.payload.filtrosRango,
                cargandoProcsProgramados:true
            }
        }
        
        case MODIFICAR_FILTROS_ESTADOS: {
            return {
                ...state,
                filtrosProcsProgramadosEstado: action.payload,
            }
        }

        case ACTUALIZAR_DOCSXACTIVO:{
            return {
                ...state,
                docsXactivoList: action.payload
            }
        };

        case SET_FILTERS:{
            return {
                ...state,
                filtros: action.payload
            }
        }
        
        case SET_INFO_DASHBOARD_ACTIVOS:{
            return {
                ...state,
                infoActivosDashboard: action.payload
            }
        }

        default:
            return state;

    }
  }

  export default activoReducer;